module.exports = __webpack_public_path__ + "img/help-mail.116cbf09.svg";